import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, LogIn, Wheat } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("em_token")) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("em_token", data.access_token);
      localStorage.setItem("em_admin_email", data.email);
      toast.success("Hoş geldiniz.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-5 py-16" data-testid="page-admin-login">
      <form onSubmit={submit} className="w-full max-w-md rounded-sm border p-8 lg:p-10" style={{ borderColor: "var(--em-border)", background: "var(--em-stone)" }}>
        <div className="inline-flex items-center gap-2.5">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full" style={{ background: "var(--em-terracotta-light)", color: "var(--em-terracotta-hover)" }}>
            <Wheat size={18} />
          </span>
          <span className="font-serif text-lg font-semibold">Ekşi Maya Gurmesi</span>
        </div>
        <h1 className="font-serif text-2xl font-semibold mt-6">Yönetici Girişi</h1>
        <p className="text-sm mt-2 text-[color:var(--em-espresso-soft)]">Başvuruları ve siparişleri yönetmek için giriş yapın.</p>

        <label className="block mt-6">
          <span className="block text-sm font-medium mb-2">E-posta</span>
          <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
        </label>
        <label className="block mt-4">
          <span className="block text-sm font-medium mb-2">Şifre</span>
          <input type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
        </label>

        <button type="submit" disabled={loading} className="btn-terracotta mt-7 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold disabled:opacity-60" data-testid="admin-login-submit">
          <LogIn size={16} /> {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}

const inputCls = "w-full border border-[color:var(--em-border)] rounded-sm bg-white px-4 py-3 text-sm text-[color:var(--em-espresso)] focus:outline-none focus:border-[color:var(--em-terracotta)] focus:ring-1 focus:ring-[color:var(--em-terracotta)]";
